import { Box, CssBaseline, ThemeProvider } from '@mui/material'
import type { Theme } from '@mui/material/styles'
import Layout from 'components/structure/Layout'
import { LIGHT_THEME } from 'constants/theme'
import React, { useEffect, useState } from 'react'
import { pingBackend } from 'api/team'
import MainAppBar from 'components/structure/MainAppBar'
import './App.css'
import { Routing } from 'Routing'
import Footer from "./components/structure/Footer";

function App() {
  const [theme, setTheme] = useState<Theme>(LIGHT_THEME)

  useEffect(() => { pingBackend() }, [])

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline/>
      <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <MainAppBar setTheme={setTheme}/>
        <Layout>
          <Routing/>
        </Layout>
        <Footer/>
      </Box>
    </ThemeProvider>
  )
}

export default App
